<template>
  <PersonalLayout>
    <template v-slot:header>
      <AppHeader />
    </template>
    <template v-slot:side>
      <router-link to="/personal-objects" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M20 7L12 3L4 7M20 7L12 11M20 7V17L12 21M12 11L4 7M12 11V21M4 7V17L12 21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
         <span>{{ $t('nav.objects') }}</span>
      </router-link>
      <router-link to="/my-fonts" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M4 7V4H20V7M9 20H15M12 4V20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
         <span>{{ $t('nav.fonts') }}</span>
      </router-link>
      <router-link to="/my-processings" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
         <span>{{ $t('nav.processing') }}</span>
      </router-link>
      <div class="side-slide active">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M21 4H3C1.89543 4 1 4.89543 1 6V18C1 19.1046 1.89543 20 3 20H21C22.1046 20 23 19.1046 23 18V6C23 4.89543 22.1046 4 21 4Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M1 10H23" stroke="currentColor" stroke-width="2"/></svg>
         <span>{{ $t('nav.subscription') }}</span>
      </div>
      <router-link to="/personal-account" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
         <span>{{ $t('common.account') }}</span>
      </router-link>
      <router-link to="/personal-security" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
         <span>{{ $t('nav.security') }}</span>
      </router-link>
      <router-link v-if="isAdmin" to="/admin" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 15C15.866 15 19 11.866 19 8C19 4.13401 15.866 1 12 1C8.13401 1 5 4.13401 5 8C5 11.866 8.13401 15 12 15Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.21 13.89L7 23L12 20L17 23L15.79 13.88" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
         <span>{{ $t('nav.admin') }}</span>
      </router-link>
      <div class="side-slide logout-slide" @click="handleLogout">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><polyline points="16,17 21,12 16,7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
         <span>{{ $t('common.logout') }}</span>
      </div>
    </template>
    <template v-slot:content>
      <div class="content-block">
        <div class="subscription-header">
           <h1>{{ $t('legacy.Моя подписка') }}</h1>
           <p class="subscription-description">{{ $t('legacy.Управление вашей подпиской на сервис') }}</p>
        </div>
      </div>
      
      <div class="spacer-10"></div>

      <div v-if="loading" class="loading-state">
         <p>{{ $t('common.loading') }}</p>
      </div>

      <template v-else>
        <div class="content-block content-block--full">
          <div class="subscription-status">
            <div class="status-icon" :class="{ 'is-paid': isPaid }">
              <svg v-if="isPaid" width="48" height="48" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" 
                  fill="#FFD700" stroke="#FFD700" stroke-width="2"/>
              </svg>
              <svg v-else width="48" height="48" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="#999" stroke-width="2"/>
                <path d="M12 8V12M12 16H12.01" stroke="#999" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </div>
            
            <div class="status-info">
              <h2>{{ subscriptionTitle }}</h2>
              <p v-if="isPaid && subscription.subscription_end_date" class="expiry-date">
                 {{ $t('legacy.Действует до:') }} {{ formatDate(subscription.subscription_end_date) }}
              </p>
              <p v-if="isPaid" class="plan-name">
                 {{ $t('legacy.Тариф:') }} {{ getPlanName(subscription.subscription_plan) }}
              </p>
              <p v-if="isPaid && subscriptionProvider" class="plan-name">
                {{ $t('legacy.paymentProviderUsed', { provider: subscriptionProviderLabel }) }}
              </p>
            </div>
          </div>

          <div v-if="isPaid && !isAdmin" class="autorenewal-section">
            <div class="autorenewal-header">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M1 4V10H7M23 20V14H17M20.49 9C19.9828 7.56678 19.1209 6.28427 17.9845 5.27489C16.8482 4.26551 15.4745 3.56 14 3.22C12.5256 2.87999 10.9879 2.91512 9.53108 3.3224C8.07428 3.72969 6.7368 4.49595 5.64 5.55999L1 10M23 14L18.36 18.44C17.2632 19.5041 15.9257 20.2703 14.4689 20.6776C13.0121 21.0849 11.4744 21.12 10 20.78C8.52554 20.44 7.1518 19.7345 6.01547 18.7251C4.87913 17.7157 4.01717 16.4332 3.51 15" 
                  stroke="#496782" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
               <h3>{{ isManualRenewal ? $t('legacy.manualRenewal') : $t('legacy.Автопродление') }}</h3>
            </div>
            
            <div v-if="isManualRenewal" class="autorenewal-status no-method">
              <div class="autorenewal-status-badge no-method-badge">{{ $t('legacy.manualRenewal') }}</div>
              <p class="autorenewal-hint">
                {{ $t('legacy.prodamusManualRenewal') }}
              </p>
            </div>

            <div v-else-if="autoRenew && hasSavedPaymentMethod" class="autorenewal-status active">
               <div class="autorenewal-status-badge active-badge">{{ $t('legacy.Включено') }}</div>
              <p class="autorenewal-hint">
                 {{ $t('legacy.dynamic.nextCharge', { date: formatDate(subscription.subscription_end_date) }) }}
              </p>
              <div v-if="!showCancelConfirm">
                <button class="cancel-renew-btn" @click="showCancelConfirm = true">
                   {{ $t('legacy.Отменить автопродление') }}
                </button>
              </div>
              <div v-else class="cancel-confirm-box">
                 <p>{{ $t('legacy.dynamic.cancelRenewalConfirm', { date: formatDate(subscription.subscription_end_date) }) }}</p>
                <div class="cancel-confirm-actions">
                  <button 
                    class="cancel-confirm-yes" 
                    @click="cancelAutoRenewal"
                    :disabled="cancellingSubscription"
                  >
                     {{ cancellingSubscription ? $t('legacy.Отмена...') : $t('legacy.Да, отменить') }}
                  </button>
                  <button class="cancel-confirm-no" @click="showCancelConfirm = false">
                     {{ $t('legacy.Нет, оставить') }}
                  </button>
                </div>
              </div>
            </div>

            <div v-else-if="!autoRenew" class="autorenewal-status cancelled">
               <div class="autorenewal-status-badge cancelled-badge">{{ $t('legacy.Отменено') }}</div>
              <p class="autorenewal-hint">
                 {{ $t('legacy.dynamic.renewalCancelled', { date: formatDate(subscription.subscription_end_date) }) }}
              </p>
            </div>

            <div v-else class="autorenewal-status no-method">
               <div class="autorenewal-status-badge no-method-badge">{{ $t('legacy.Способ оплаты не сохранён') }}</div>
              <p class="autorenewal-hint">
                 {{ $t('legacy.dynamic.noPaymentMethod', { date: formatDate(subscription.subscription_end_date) }) }}
              </p>
            </div>
          </div>

          <div v-if="isPaid && !isAdmin && !isManualRenewal" class="payment-methods-section">
            <div class="autorenewal-header">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <rect x="1" y="4" width="22" height="16" rx="2" stroke="#496782" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M1 10H23" stroke="#496782" stroke-width="2"/>
              </svg>
               <h3>{{ $t('legacy.Способы оплаты') }}</h3>
            </div>

            <div class="card-block">
              <div class="saved-card" :class="{ 'card-inactive': !hasSavedPaymentMethod }">

                <!-- Для карточных методов: чип -->
                <div v-if="isCardMethod || !hasSavedPaymentMethod" class="card-chip">
                  <svg width="28" height="22" viewBox="0 0 28 22" fill="none">
                    <rect width="28" height="22" rx="4" fill="#c8a951"/>
                    <rect x="3" y="7" width="8" height="8" rx="2" fill="#a88a38"/>
                    <line x1="11" y1="7" x2="11" y2="15" stroke="#c8a951" stroke-width="1"/>
                    <line x1="3" y1="11" x2="11" y2="11" stroke="#c8a951" stroke-width="1"/>
                  </svg>
                </div>

                <!-- Для некарточных методов: иконка метода -->
                <div v-else class="card-chip method-icon-wrap">
                  <!-- SberPay -->
                  <template v-if="paymentMethodType === 'sberbank'">
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                      <circle cx="14" cy="14" r="14" fill="#21A038"/>
                      <path d="M20.5 9.5L14 6L7.5 9.5V14C7.5 17.59 10.28 20.95 14 22C17.72 20.95 20.5 17.59 20.5 14V9.5Z" fill="white"/>
                    </svg>
                  </template>
                  <!-- T-Pay -->
                  <template v-else-if="paymentMethodType === 'tinkoff_bank'">
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                      <circle cx="14" cy="14" r="14" fill="#FFDD2D"/>
                      <text x="14" y="19" text-anchor="middle" font-family="Arial, sans-serif" font-size="12" font-weight="900" fill="#333">T</text>
                    </svg>
                  </template>
                  <!-- ЮMoney -->
                  <template v-else-if="paymentMethodType === 'yoo_money'">
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                      <circle cx="14" cy="14" r="14" fill="#8B5CF6"/>
                      <text x="14" y="19" text-anchor="middle" font-family="Arial, sans-serif" font-size="9" font-weight="700" fill="white">ЮМ</text>
                    </svg>
                  </template>
                  <!-- СБП -->
                  <template v-else-if="paymentMethodType === 'sbp'">
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                      <circle cx="14" cy="14" r="14" fill="#1C6FE4"/>
                      <text x="14" y="19" text-anchor="middle" font-family="Arial, sans-serif" font-size="8" font-weight="700" fill="white">СБП</text>
                    </svg>
                  </template>
                  <!-- Неизвестный тип -->
                  <template v-else>
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                      <rect x="1" y="4" width="22" height="16" rx="2" fill="rgba(255,255,255,0.25)" stroke="rgba(255,255,255,0.7)" stroke-width="1.5"/>
                      <path d="M1 9H23" stroke="rgba(255,255,255,0.7)" stroke-width="1.5"/>
                    </svg>
                  </template>
                </div>

                <div class="card-info">
                  <!-- Карточный метод: маска номера -->
                  <div v-if="isCardMethod" class="card-number">
                     {{ hasSavedPaymentMethod ? cardDisplayNumber : '•••• •••• •••• ••••' }}
                  </div>
                  <!-- Некарточный метод: название -->
                  <div v-else class="card-number method-name">{{ paymentMethodLabel }}</div>

                  <div class="card-label">
                     {{ hasSavedPaymentMethod ? cardDisplayLabel : $t('legacy.Способ оплаты не сохранён') }}
                  </div>
                </div>

                <div class="card-brand" v-if="hasSavedPaymentMethod && isCardMethod">
                  <template v-if="isMastercard">
                    <svg width="38" height="24" viewBox="0 0 38 24" fill="none">
                      <circle cx="15" cy="12" r="10" fill="#EB001B" opacity="0.9"/>
                      <circle cx="23" cy="12" r="10" fill="#F79E1B" opacity="0.9"/>
                      <path d="M19 4.8C21 6.4 22.3 8.9 22.3 12C22.3 15.1 21 17.6 19 19.2C17 17.6 15.7 15.1 15.7 12C15.7 8.9 17 6.4 19 4.8Z" fill="#FF5F00"/>
                    </svg>
                  </template>
                  <template v-else-if="isVisa">
                    <svg width="48" height="16" viewBox="0 0 48 16" fill="none">
                      <text x="0" y="13" font-family="Arial, sans-serif" font-size="15" font-weight="bold" font-style="italic" fill="white" letter-spacing="1">VISA</text>
                    </svg>
                  </template>
                  <template v-else-if="isMir">
                    <svg width="42" height="18" viewBox="0 0 42 18" fill="none">
                      <text x="0" y="14" font-family="Arial, sans-serif" font-size="13" font-weight="bold" fill="white" letter-spacing="1">МИР</text>
                    </svg>
                  </template>
                  <template v-else>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect x="1" y="4" width="22" height="16" rx="2" stroke="rgba(255,255,255,0.7)" stroke-width="1.5"/>
                      <path d="M1 9H23" stroke="rgba(255,255,255,0.7)" stroke-width="1.5"/>
                    </svg>
                  </template>
                </div>
              </div>

              <div class="card-consent">
                <label class="consent-label">
                  <input
                    type="checkbox"
                    :checked="hasSavedPaymentMethod"
                    disabled
                    class="consent-checkbox"
                  />
                  <span>{{ $t('legacy.Сохранить способ оплаты для автоматической оплаты подписки') }}</span>
                </label>
              </div>

              <template v-if="hasSavedPaymentMethod">
                <div v-if="!showRemoveCardConfirm" class="card-actions">
                   <button class="remove-card-btn" @click="showRemoveCardConfirm = true">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <polyline points="3,6 5,6 21,6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M19 6L18.1 19.1C18 20.2 17.1 21 16 21H8C6.9 21 6 20.2 5.9 19.1L5 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M10 11V17M14 11V17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M9 6V4C9 3.4 9.4 3 10 3H14C14.6 3 15 3.4 15 4V6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                     {{ $t('legacy.Отвязать способ оплаты') }}
                  </button>
                </div>

                <div v-else class="remove-card-confirm">
                   <p>{{ $t('legacy.removePaymentConfirm') }}</p>
                  <div class="cancel-confirm-actions">
                    <button
                      class="cancel-confirm-yes"
                      @click="removeCard"
                      :disabled="removingCard"
                    >
                       {{ removingCard ? $t('legacy.Удаление...') : $t('legacy.Да, отвязать') }}
                    </button>
                    <button class="cancel-confirm-no" @click="showRemoveCardConfirm = false">
                       {{ $t('common.cancel') }}
                    </button>
                  </div>
                </div>
              </template>

              <template v-else>
                <div class="card-actions">
                  <button class="remove-card-btn" disabled style="opacity:0.4;cursor:not-allowed;">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <polyline points="3,6 5,6 21,6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M19 6L18.1 19.1C18 20.2 17.1 21 16 21H8C6.9 21 6 20.2 5.9 19.1L5 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M10 11V17M14 11V17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M9 6V4C9 3.4 9.4 3 10 3H14C14.6 3 15 3.4 15 4V6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                     {{ $t('legacy.Отвязать способ оплаты') }}
                  </button>
                </div>
                 <p class="card-hint">{{ $t('legacy.cardAutoSaveHint') }}</p>
              </template>
            </div>
          </div>

          <div class="features-list">
             <h3>{{ isPaid ? $t('legacy.Ваши возможности:') : $t('legacy.Доступные возможности:') }}</h3>
            <ul>
              <li class="feature-item available">
                <span class="feature-icon">✓</span>
                 {{ $t('legacy.Работа в конструкторе') }}
              </li>
              <li class="feature-item" :class="{ 'available': isPaid, 'restricted': !isPaid }">
                <span class="feature-icon">{{ isPaid ? '✓' : '✕' }}</span>
                 {{ $t('legacy.Полный банк элементов') }}
              </li>
              <li class="feature-item available">
                <span class="feature-icon">✓</span>
                 {{ $t('legacy.Сохранение изображений') }} {{ !isPaid ? $t('legacy.(с водяным знаком)') : '' }}
              </li>
              <li class="feature-item" :class="{ 'available': isPaid, 'restricted': !isPaid }">
                <span class="feature-icon">{{ isPaid ? '✓' : '✕' }}</span>
                 {{ $t('legacy.dynamic.aiRealism', { credits: currentCredits }) }}
              </li>
              <li class="feature-item" :class="{ 'available': isPaid, 'restricted': !isPaid }">
                <span class="feature-icon">{{ isPaid ? '✓' : '✕' }}</span>
                 {{ $t('legacy.Добавление своих элементов') }}
              </li>
              <li class="feature-item" :class="{ 'available': isPaid, 'restricted': !isPaid }">
                <span class="feature-icon">{{ isPaid ? '✓' : '✕' }}</span>
                {{ $t('subscription.customFonts') }}
              </li>
              <li class="feature-item" :class="{ 'available': isPremium, 'restricted': !isPremium }">
                <span class="feature-icon">{{ isPremium ? '✓' : '✕' }}</span>
                 {{ $t('legacy.Калькулятор проекта') }}
              </li>
              <li class="feature-item" :class="{ 'available': isPremium, 'restricted': !isPremium }">
                <span class="feature-icon">{{ isPremium ? '✓' : '✕' }}</span>
                 {{ $t('legacy.Экспорт сметы в PDF и Excel') }}
              </li>
            </ul>
          </div>

          <div v-if="isPremium && creditPackages.length > 0" class="credits-section">
             <h3>{{ $t('legacy.Докупить ИИ-кредиты') }}</h3>
             <p class="credits-hint">{{ $t('legacy.dynamic.currentCredits', { credits: currentCredits }) }}</p>
            <div class="credits-packages">
              <div v-for="pkg in creditPackages" :key="pkg.id" class="credit-package-card">
                <div class="package-credits">{{ pkg.credits }}</div>
                 <div class="package-label">{{ $t('processing.credits') }}</div>
                 <div class="package-price">{{ $formatCurrency(pkg.price, 'RUB') }}</div>
                 <div v-if="pkg.price_usd" class="package-price">{{ $formatCurrency(pkg.price_usd, 'USD') }} · Prodamus</div>
                <button 
                  class="package-buy-btn" 
                  @click="handleBuyCredits(pkg)"
                  :disabled="purchasingPackage === pkg.id"
                >
                   {{ purchasingPackage === pkg.id ? $t('legacy.Оформление...') : $t('legacy.Купить') }}
                </button>
              </div>
            </div>
          </div>

          <div v-if="!isPaid" class="upgrade-section">
             <p class="upgrade-hint">{{ $t('legacy.Получите доступ ко всем возможностям Макетта') }}</p>
            <router-link to="/subscription/plans" class="upgrade-btn">
               {{ $t('legacy.Оформить подписку') }}
            </router-link>
          </div>

          <div v-else-if="isBase" class="upgrade-section">
             <p class="upgrade-hint">{{ $t('subscription.premiumUpgradeHint') }}</p>
            <router-link to="/subscription/plans" class="upgrade-btn">
               {{ $t('legacy.Перейти на Premium') }}
            </router-link>
          </div>
        </div>
      </template>
    </template>
  </PersonalLayout>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue';
import PersonalLayout from '@/layout/PersonalLayout.vue';
import { getSubscriptionStatus } from '@/api/subscription';
import { cancelSubscription, removePaymentMethod } from '@/api/payments';
import api from '@/api/axios';
import { useToast } from 'vue-toastification';

export default {
  name: 'PersonalSubscriptionPage',
  components: {
    AppHeader,
    PersonalLayout,
  },
  data() {
    return {
      loading: true,
      subscription: null,
      creditPackages: [],
      currentCredits: 0,
      purchasingPackage: null,
      toast: null,
      cancellingSubscription: false,
      showCancelConfirm: false,
      removingCard: false,
      showRemoveCardConfirm: false,
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters['subscription/isAdmin'];
    },
    isPaid() {
      if (this.isAdmin) return true;
      const type = this.subscription?.subscription_type;
      return (type === 'paid' || type === 'base' || type === 'premium') && this.subscription?.is_active;
    },
    isBase() {
      if (this.isAdmin) return false;
      const type = this.subscription?.subscription_type;
      const plan = this.subscription?.subscription_plan;
      const isActive = this.subscription?.is_active;
      if (!isActive) return false;
      if (type === 'base') return true;
      if (type === 'paid' && plan === 'base') return true;
      return false;
    },
    isPremium() {
      if (this.isAdmin) return true;
      const type = this.subscription?.subscription_type;
      const plan = this.subscription?.subscription_plan;
      const isActive = this.subscription?.is_active;
      if (!isActive) return false;
      if (type === 'premium') return true;
      if (type === 'paid' && plan !== 'base') return true;
      return false;
    },
    subscriptionTitle() {
      if (this.isAdmin) return this.$t('legacy.adminPremium');
      if (!this.isPaid) return this.$t('legacy.Бесплатный тариф');
      const type = this.subscription?.subscription_type;
      const plan = this.subscription?.subscription_plan;
      if (plan === 'base' || type === 'base') return 'Base';
      if (plan === 'premium' || type === 'premium') return 'Premium';
      if (type === 'paid') return 'Premium';
       return this.$t('legacy.Платная подписка');
    },
    autoRenew() {
      return this.subscription?.subscription_auto_renew !== false;
    },
    subscriptionProvider() {
      return this.subscription?.payment_provider || this.subscription?.subscription_payment_provider || this.subscription?.provider || null;
    },
    subscriptionProviderLabel() {
      if (this.subscriptionProvider === 'prodamus') return 'Prodamus';
      if (this.subscriptionProvider === 'yookassa') return 'YooKassa';
      return this.subscriptionProvider;
    },
    isManualRenewal() {
      return this.subscriptionProvider === 'prodamus';
    },
    hasSavedPaymentMethod() {
      return !!this.subscription?.has_saved_payment_method;
    },
    paymentMethodType() {
      return this.subscription?.yookassa_payment_method_type || null;
    },
    isCardMethod() {
      const t = this.paymentMethodType;
      return !t || t === 'bank_card' || t === 'mir_pay';
    },
    cardLast4() {
      return this.subscription?.yookassa_card_last4 || null;
    },
    cardType() {
      return this.subscription?.yookassa_card_type || null;
    },
    cardTitle() {
      return this.subscription?.yookassa_card_title || null;
    },
    cardDisplayNumber() {
      if (!this.isCardMethod) return '';
      if (this.cardLast4) {
        return `•••• •••• •••• ${this.cardLast4}`;
      }
      return '•••• •••• •••• ••••';
    },
    cardDisplayLabel() {
      if (!this.isCardMethod) return this.paymentMethodLabel;
      if (this.cardTitle) return this.cardTitle;
      if (this.cardType) return `${this.cardType}`;
       return this.$t('legacy.Карта для автоматических платежей');
    },
    paymentMethodLabel() {
      const map = {
         bank_card: this.$t('legacy.Банковская карта'),
        mir_pay: 'Mir Pay',
        sberbank: 'SberPay',
        tinkoff_bank: 'T-Pay',
         yoo_money: this.$t('legacy.ЮMoney'),
         sbp: this.$t('legacy.СБП'),
      };
       return map[this.paymentMethodType] || this.cardTitle || this.$t('legacy.Способ оплаты');
    },
    isMastercard() {
      return this.isCardMethod && this.cardType && this.cardType.toLowerCase().includes('master');
    },
    isVisa() {
      return this.isCardMethod && this.cardType && this.cardType.toLowerCase().includes('visa');
    },
    isMir() {
      return this.isCardMethod && this.cardType && (this.cardType.toLowerCase().includes('mir') || this.cardType.toLowerCase() === 'мир');
    },
  },
  async mounted() {
    this.toast = useToast();
    await this.loadSubscription();
  },
  methods: {
    async handleLogout() {
      await this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
    async loadSubscription() {
      this.loading = true;
      try {
        const status = await getSubscriptionStatus();
        this.subscription = status;
        this.currentCredits = status.ai_credits || 0;
        await this.$store.dispatch('subscription/refresh');

        if (this.isPremium) {
          await this.loadCreditPackages();
        }
      } catch (error) {
        console.error('Error loading subscription:', error);
      } finally {
        this.loading = false;
      }
    },
    async loadCreditPackages() {
      try {
        const response = await api.get('/credits/packages');
        this.creditPackages = response.data;
      } catch (error) {
        console.error('Error loading credit packages:', error);
      }
    },
    async handleBuyCredits(pkg) {
      this.purchasingPackage = pkg.id;
      try {
        await this.$router.push({
          path: '/credits/payment',
          query: { packageId: pkg.id }
        });
      } catch (error) {
        console.error('Could not open credit payment:', error);
        this.toast.error(this.$t('legacy.Ошибка создания платежа'));
      } finally {
        this.purchasingPackage = null;
      }
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return this.$formatDate(date, {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });
    },
    getPlanName(plan) {
      const names = {
         monthly: this.$t('legacy.1 месяц'),
         semi_annual: this.$t('legacy.6 месяцев'),
         yearly: this.$t('legacy.1 год')
      };
      return names[plan] || plan;
    },
    async cancelAutoRenewal() {
      if (this.cancellingSubscription) return;
      this.cancellingSubscription = true;
      this.showCancelConfirm = false;
      try {
        await cancelSubscription();
         this.toast.success(this.$t('legacy.Автопродление отменено. Подписка будет действовать до конца текущего периода.'));
        await this.loadSubscription();
      } catch (error) {
         const msg = error.response?.data?.error || this.$t('legacy.Ошибка отмены автопродления');
        this.toast.error(msg);
      } finally {
        this.cancellingSubscription = false;
      }
    },
    async removeCard() {
      if (this.removingCard) return;
      this.removingCard = true;
      this.showRemoveCardConfirm = false;
      try {
        await removePaymentMethod();
         this.toast.success(this.$t('legacy.Способ оплаты отвязан. Автопродление отключено.'));
        await this.loadSubscription();
      } catch (error) {
         const msg = error.response?.data?.error || this.$t('legacy.Ошибка при отвязке способа оплаты');
        this.toast.error(msg);
      } finally {
        this.removingCard = false;
      }
    }
  }
};
</script>

<style scoped>
.side-slide {
  display: block;
  padding: 10px;
  font-weight: 700;
  font-size: 16px;
  line-height: 120%;
  color: #1a1a1a;
  cursor: pointer;
  border-radius: 6px;
  text-decoration: none;
  transition: background 0.2s;
}

.side-slide:hover {
  background: #f5f5f5;
}

.side-slide.active {
  background: #f0f0f0;
  color: #496782;
}

.side-slide + .side-slide {
  margin-top: 4px;
}

.spacer-10 {
  height: 10px;
}

.content-block {
  border: 1px solid #fafafa;
  width: 100%;
  background-color: white;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 3px 3px 4px 0 rgba(178, 176, 173, 0.2);
}

.content-block--full {
  width: 100%;
}

.subscription-header h1 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
}

.subscription-description {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.loading-state {
  text-align: center;
  padding: 40px;
  color: #666;
}

.subscription-status {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
  margin-bottom: 24px;
}

.status-icon {
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.status-icon.is-paid {
  background: linear-gradient(135deg, #fff8e1, #fff);
}

.status-info h2 {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
}

.expiry-date {
  font-size: 14px;
  color: #666;
  margin: 0 0 4px 0;
}

.plan-name {
  font-size: 14px;
  color: #496782;
  font-weight: 500;
  margin: 0;
}

.features-list {
  margin-bottom: 24px;
}

.features-list h3 {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 16px 0;
}

.features-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  font-size: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.feature-item:last-child {
  border-bottom: none;
}

.feature-item.available {
  color: #333;
}

.feature-item.restricted {
  color: #999;
}

.feature-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 600;
}

.feature-item.available .feature-icon {
  background: #e8f5e9;
  color: #4caf50;
}

.feature-item.restricted .feature-icon {
  background: #ffebee;
  color: #f44336;
}

.credits-badge {
  margin-left: auto;
  font-size: 13px;
  font-weight: 600;
  color: #496782;
  background: #e0f4fc;
  padding: 2px 10px;
  border-radius: 12px;
}

.credits-section {
  margin-bottom: 24px;
  padding: 24px;
  background: #f8fbff;
  border-radius: 12px;
  border: 1px solid #e0f4fc;
}

.credits-section h3 {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
}

.credits-hint {
  font-size: 14px;
  color: #666;
  margin: 0 0 16px 0;
}

.credits-packages {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.credit-package-card {
  flex: 1;
  min-width: 140px;
  max-width: 200px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 20px 16px;
  text-align: center;
  transition: all 0.2s;
}

.credit-package-card:hover {
  border-color: #496782;
  box-shadow: 0 4px 12px rgba(73, 103, 130, 0.15);
}

.package-credits {
  font-size: 32px;
  font-weight: 700;
  color: #496782;
  line-height: 1;
}

.package-label {
  font-size: 13px;
  color: #999;
  margin-bottom: 8px;
}

.package-price {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
}

.package-buy-btn {
  width: 100%;
  padding: 10px 16px;
  background: linear-gradient(135deg, #496782, #5a7a99);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.package-buy-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(73, 103, 130, 0.3);
}

.package-buy-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.upgrade-section {
  text-align: center;
  padding: 24px;
  background: linear-gradient(135deg, #e3f2fd, #f3e5f5);
  border-radius: 12px;
}

.upgrade-hint {
  font-size: 14px;
  color: #666;
  margin: 0 0 16px 0;
  line-height: 1.5;
}

.upgrade-btn {
  display: inline-block;
  padding: 14px 32px;
  background: linear-gradient(135deg, #496782, #5a7a99);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  text-decoration: none;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(73, 103, 130, 0.3);
}

.upgrade-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(73, 103, 130, 0.4);
}

.renew-section {
  text-align: center;
  padding: 20px;
}

.renew-hint {
  font-size: 14px;
  color: #666;
  margin: 0 0 12px 0;
}

.renew-btn {
  display: inline-block;
  padding: 10px 24px;
  background: #f0f0f0;
  color: #333;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  text-decoration: none;
  transition: background 0.2s;
}

.renew-btn:hover {
  background: #e0e0e0;
}

.autorenewal-section {
  margin-bottom: 24px;
  padding: 20px;
  background: #f8fbff;
  border-radius: 12px;
  border: 1px solid #e0f4fc;
}

.autorenewal-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}

.autorenewal-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.autorenewal-status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 10px;
}

.active-badge {
  background: #e8f5e9;
  color: #2e7d32;
}

.cancelled-badge {
  background: #fff3e0;
  color: #e65100;
}

.no-method-badge {
  background: #f5f5f5;
  color: #666;
}

.autorenewal-hint {
  font-size: 14px;
  color: #555;
  margin: 0 0 14px 0;
  line-height: 1.5;
}

.cancel-renew-btn {
  padding: 9px 20px;
  background: transparent;
  border: 1px solid #e74c3c;
  color: #e74c3c;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.cancel-renew-btn:hover {
  background: #fff5f5;
}

.cancel-confirm-box {
  background: #fff8f8;
  border: 1px solid #fde0de;
  border-radius: 10px;
  padding: 16px;
}

.cancel-confirm-box p {
  font-size: 14px;
  color: #555;
  margin: 0 0 14px 0;
  line-height: 1.5;
}

.cancel-confirm-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.cancel-confirm-yes {
  padding: 9px 20px;
  background: #e74c3c;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.cancel-confirm-yes:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.cancel-confirm-yes:hover:not(:disabled) {
  background: #c0392b;
}

.cancel-confirm-no {
  padding: 9px 20px;
  background: #f0f0f0;
  color: #333;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.cancel-confirm-no:hover {
  background: #e0e0e0;
}

.payment-methods-section {
  margin-bottom: 24px;
  padding: 20px;
  background: #f8fbff;
  border-radius: 12px;
  border: 1px solid #e0f4fc;
}

.card-block {
  margin-top: 4px;
}

.saved-card {
  display: flex;
  align-items: center;
  gap: 14px;
  background: linear-gradient(135deg, #26374E 0%, #496782 100%);
  border-radius: 12px;
  padding: 16px 20px;
  color: white;
  margin-bottom: 14px;
}

.card-chip {
  flex-shrink: 0;
}

.method-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-info {
  flex: 1;
}

.card-number {
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 3px;
  font-family: monospace;
  color: rgba(255,255,255,0.95);
}

.card-number.method-name {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  font-family: inherit;
}

.card-label {
  font-size: 12px;
  color: rgba(255,255,255,0.65);
  margin-top: 4px;
}

.card-brand {
  flex-shrink: 0;
}

.card-consent {
  margin-bottom: 14px;
}

.consent-label {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 14px;
  color: #444;
  cursor: default;
  line-height: 1.4;
}

.consent-checkbox {
  margin-top: 2px;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  accent-color: #496782;
}

.card-actions {
  display: flex;
  gap: 10px;
}

.remove-card-btn {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 9px 18px;
  background: transparent;
  border: 1px solid #e74c3c;
  color: #e74c3c;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.remove-card-btn:hover {
  background: #fff5f5;
}

.remove-card-confirm {
  background: #fff8f8;
  border: 1px solid #fde0de;
  border-radius: 10px;
  padding: 14px 16px;
  margin-top: 4px;
}

.remove-card-confirm p {
  font-size: 14px;
  color: #555;
  margin: 0 0 12px 0;
  line-height: 1.5;
}

.no-card-block {
  margin-top: 4px;
}

.card-inactive {
  background: linear-gradient(135deg, #8a9aaa 0%, #aabac8 100%) !important;
  opacity: 0.75;
}

.card-hint {
  font-size: 13px;
  color: #888;
  margin: 10px 0 0 0;
  line-height: 1.5;
}

@media (max-width: 500px) {
  .saved-card {
    flex-wrap: wrap;
  }

  .card-number {
    font-size: 16px;
    letter-spacing: 2px;
  }
}

@media (max-width: 768px) {
  .content-block {
    width: 100%;
    border: none;
    box-shadow: none;
    margin: 0;
    padding: 20px 16px;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  }

  .subscription-status {
    flex-direction: column;
    text-align: center;
    padding: 16px;
  }

  .status-info h2 {
    font-size: 18px;
  }

  .credits-packages {
    flex-direction: column;
  }

  .credit-package-card {
    max-width: none;
  }
}
</style>
